// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.product-attribute-container[data-v-746a895b] {\n  position: relative;\n  min-height: 340px;\n}\n", ""]);
// Exports
module.exports = exports;
